// @flow
import React from "react";
import classNames from "classnames";
import Typography from "elevate-ui/Typography";
import withStyles from "elevate-ui/withStyles";
import Button from "elevate-ui/Button";
import { withSellerLeadContext } from "../common/SellerLeadContext";

type $Props = {
  classes: Object,
  navigateToThankYou: Function,
  buttonColor: string,
};

class SellerLeadEmailConfirmation extends React.Component<$Props> {
  props: $Props;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { classes, navigateToThankYou, buttonColor } = this.props;
    return (
      <div className={classNames(classes.boxWrapper)}>
        <div className={classes.box}>
          <Typography
            type="body"
            className={classNames(classes.textContent, classes.subBody)}
          >
            Thank you! An approved local expert will follow up with a more
            detailed report shortly.
          </Typography>
          <Button
            color={buttonColor}
            className={classes.boxButton}
            type="button"
            onClick={navigateToThankYou}
            innerClassName={classes.buttonInner}
          >
            <span className={classes.boxButtonText}>Go Back</span>
          </Button>
        </div>
      </div>
    );
  }
}

const styles = (theme) => {
  return {
    boxWrapper: {
      width: "80%",
      display: "flex",
      zIndex: "1",
      position: "relative",
      flexFlow: "column",
      marginTop: "calc(20% - 20px)",
      marginBottom: "calc(10%)",
      alignItems: "center",
      justifyContent: "center",
    },
    box: {
      border: `${theme.spacing.unit}px solid white`,
      borderRadius: "10px",
      backgroundColor: theme.colors.white,
      padding: theme.spacing.unit * 3,
      opacity: "0.95",
      textAlign: "center",
      boxShadow: theme.shadows[4],
    },
    textContent: {
      lineHeight: "1.6",
    },
    subBody: { paddingBottom: `${theme.spacing.unit * 1.5}px` },
    boxButton: { bottom: "1px" },
    boxButtonText: { lineHeight: "26px !important" },
    buttonInner: { color: theme.colors.white },
  };
};
// Thank you! An approved local expert will follow up with a more detailed report shortly.
export default withSellerLeadContext(
  withStyles(styles)(SellerLeadEmailConfirmation)
);
